import { render, staticRenderFns } from "./OrganismFeedSectionLoading.vue?vue&type=template&id=0ef51c0e"
import script from "./OrganismFeedSectionLoading.vue?vue&type=script&lang=js"
export * from "./OrganismFeedSectionLoading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports